import { Body, Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { ContactModelDefault, ErrorResponse } from '@gtpl/shared-models/common-models';
import { Rack } from './racks.entity';
import { RackDTO } from './dto/racks.dto';
import { RackAdapter } from './dto/racks.adapter';
import { RackRequest } from './dto/racks.request';
import { AllRacksResponseModel, CommonResponse, RackDetails, RackDropDownDto, RackDropDownResponseModel, RackResponseModel, RacksForZoneId } from '@gtpl/shared-models/masters';
import { ZoneByIdDto } from './dto/zone-id-request-dto';
import { RackIdRequest } from './dto/rackId.request';
import { PlantIdRequest } from '@gtpl/shared-models/warehouse-management';
import appSettings from 'apps/services/config';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { RackRepository } from './dto/rack-repository';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';


@Injectable()
export class RacksService {
    constructor(
      private logService:LogsService,

        @InjectRepository(Rack) private rackRepository: Repository<Rack>,
        private rackAdapter: RackAdapter,
    ) { }

    async getRackWithoutRelations(zoneId: number, rackName: string): Promise<Rack> {
        console.log(zoneId, rackName);
        const response = await this.rackRepository.findOne({
            where: { zoneId: Raw(alias => `zone_id = '${zoneId}'`), rackName: Raw(alias => `rack_name = '${rackName}'`) },
        });
        console.log(response);
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createRack(rackDto: RackDTO, isUpdate: boolean = false, @Req() request: Request): Promise<RackResponseModel> {
        try {
            console.log('rackDto' + rackDto);
            console.log('rackDto' + isUpdate);
            if (!isUpdate) {
                const rackEntity = await this.getRackWithoutRelations(rackDto.zoneId, rackDto.rackName);
                if (rackEntity) {
                    throw new RackResponseModel(false,11104, 'Rack already exists');
                }
            } else {
                const rackEntity = await this.getRackWithoutRelationsForUpdate(rackDto.rackCode, rackDto.rackName, rackDto.rackId, rackDto.zoneId, rackDto.plantId);
                if (rackEntity) {
console.log(rackEntity);
console.log(rackEntity.rackId +"*"+ rackDto.rackId)
                    if (rackEntity.rackId != rackDto.rackId) {
                        throw new RackResponseModel(false,11104, 'Rack already exists');
                    }
                }
            }
            const rackEntity: Rack = this.rackAdapter.convertDtoToEntity(rackDto, isUpdate);
            const savedRackEntity: Rack = await this.rackRepository.save(rackEntity);
            const savedRackDto: RackDTO = this.rackAdapter.convertEntityToDto(savedRackEntity);

            if (savedRackEntity) {
                const response = new RackResponseModel(true, isUpdate ? 11100 : 11101, isUpdate ? 'Rack Updated Successfully' : 'Rack Created Successfully', savedRackDto);
                const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'Rack', savedRackEntity.rackId, true, '',savedRackEntity.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new RackResponseModel(false,11106, 'Rack saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }

    async getAllRacksForPlant(plantId: PlantIdRequest): Promise<AllRacksResponseModel> {
        try {
            console.log(plantId);
            const racksDetails: RackDetails[] = [];
            // retrieves all plants
            const rackEntities: Rack[] = await this.rackRepository.find({
                relations: ['zoneMasterInfo'],
                where: {plantId:plantId.plantId},
                order: { rackCode: "ASC" },
            });
            if (rackEntities.length > 0) {
                rackEntities.forEach(rackEntity => {
                    const convertedRackDto: RackDetails = this.rackAdapter.convertEntityDetails(rackEntity);
                    racksDetails.push(convertedRackDto);
                });
                const response = new AllRacksResponseModel(true, 11208, "Racks retrieved successfully", racksDetails);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    // async getAllRacks(): Promise<AllRacksResponseModel> {
    //     try {
    //         const racksDetails: RackDetails[] = [];
    //         // retrieves all plants
    //         const rackEntities: Rack[] = await this.rackRepository.find({
    //             relations: ['zoneMasterInfo'],
    //             order: { rackCode: "ASC" },
    //         });
    //         if (rackEntities.length > 0) {
    //             rackEntities.forEach(rackEntity => {
    //                 const convertedRackDto: RackDetails = this.rackAdapter.convertEntityDetails(rackEntity);
    //                 racksDetails.push(convertedRackDto);
    //             });
    //             const response = new AllRacksResponseModel(true, 11208, "Racks retrieved successfully", racksDetails);
    //             return response;
    //         } else {
    //             throw new RackResponseModel(false,99998, 'No Records Found');
    //         }
    //     } catch (err) {
    //         throw err;
    //     }
    // }

    async getAllRacks(): Promise<AllRacksResponseModel> {
        try{
            const manager = getManager();
            const query = `SELECT u.unit_name as allocatedPlantName,zm.zone_name AS allocatedZoneName,r.allocated_plant_id AS allocatedPlantId, r.allocated_zone_id AS allocatedZoneId, SUM(IF(rp.occupancy = "Not Occupied", 1,0)) AS availCount,COUNT(rp.rack_id) AS rackCount,r.rack_id as rackId, r.plant_id as unitId, r.zone_id as zoneId, r.rack_name as rackName,z.zone_name as zoneName,uc.unit_name as plantName,r.is_active as isActive,r.created_user as createdUser,r.updated_user as updatedUser,r.rack_code as rackCode,r.reserved_for_dummy as reservedForDummy,r.rack_Type as rackPosition,r.version_flag as versionFlag FROM ` + appSettings.masters_db  + `.rack r
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = r.plant_id
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = r.allocated_plant_id
            LEFT JOIN ` + appSettings.masters_db + `.rack_position  rp ON rp.rack_id = r.rack_id
            LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id = r.zone_Id 
            LEFT JOIN ` + appSettings.masters_db + `.zone_master zm ON zm.zone_id = r.allocated_zone_id 
            GROUP BY r.rack_id ORDER BY r.plant_id, r.zone_id,r.rack_name`

            const data = await manager.query(query)
            if(data.length > 0){
            const response = new AllRacksResponseModel(true, 11208, "Racks retrieved successfully", data);
            const newLogDto = new LogsDto(1,'view', 'Racks', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            }else{
                throw new RackResponseModel(false,99998,'No Record Found');
            }
           
            
        }catch(err){
            return err
        }

    }

    async getAllActiveRacks(): Promise<AllRacksResponseModel> {
        // const page: number = 1;
        try {
            const rackEntities: RackDetails[] = [];
            //retrieves all companies
            const RacksEntities: Rack[] = await this.rackRepository.find({
                order: { 'rackCode': 'ASC' },
            });
            console.log(RacksEntities)
            if (RacksEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                RacksEntities.forEach(rackEntity => {
                    const rackData = new RackDetails(rackEntity.rackId, rackEntity.rackName, rackEntity.rackCode,rackEntity.reservedForDummy, rackEntity.zoneMasterInfo.zoneId, rackEntity.zoneMasterInfo.zoneName, rackEntity.createdUser, rackEntity.updatedUser, rackEntity.isActive, rackEntity.versionFlag,0,0,"","","");
                    rackEntities.push(rackData);
                });
                const response = new AllRacksResponseModel(true, 11208, "Racks retrieved successfully", rackEntities);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'Data not found'); rackEntities
            }
        } catch (err) {
            throw err;
        }
    }

    async activateOrDeactivateRack(rackReq: RackRequest): Promise<RackResponseModel> {
        try {
            const rackExists = await this.getRackById(rackReq.rackId);
            if (rackExists) {
                if (rackReq.versionFlag !== rackExists.versionFlag) {
                    throw new RackResponseModel(false,10113, 'Someone updated the current Rack information.Refresh and try again');
                } else {

                    const rackStatus = await this.rackRepository.update(
                        { rackId: rackReq.rackId },
                        { isActive: rackReq.isActive, updatedUser: rackReq.updatedUser });

                    if (rackExists.isActive) {
                        if (rackStatus.affected) {
                            const rackResponse: RackResponseModel = new RackResponseModel(true, 10115, 'Rack is de-activated successfully');
                            return rackResponse;
                        } else {
                            throw new RackResponseModel(false,10111, 'Rack is already deactivated');
                        }
                    } else {
                        if (rackStatus.affected) {
                            const rackResponse: RackResponseModel = new RackResponseModel(true, 10114, 'Rack is activated successfully');
                            return rackResponse;
                        } else {
                            throw new RackResponseModel(false,10112, 'Rack is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new RackResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getRackById(rackId: number): Promise<Rack> {
        //  console.log(employeeId);
        const Response = await this.rackRepository.findOne({
            where: { rackId: rackId },
        });
        // console.log(employeeResponse);
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getAllRackDropDown(): Promise<RackDropDownResponseModel> {
        try {
            const rackDto: RackDropDownDto[] = [];
            const rackEntities: Rack[] = await this.rackRepository.find({ select: ['rackId', 'rackCode'], where: { isActive: true }, order: { rackCode: "ASC" } })


            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rackEntity => {
                    rackDto.push(new RackDropDownDto(rackEntity.rackId, rackEntity.rackCode));
                });
                const response = new RackDropDownResponseModel(true, 11108, "rack retrieved successfully", rackDto);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }


    async getRackdataById(rackreq: RackRequest): Promise<RackDropDownDto> {
        const RackEntities = await this.rackRepository.findOne({
            select: ['rackId', 'rackCode'],
            where: { rackId: rackreq.rackId }
        });
        if (RackEntities) {
            const response = new RackDropDownDto(RackEntities.rackId, RackEntities.rackCode);
            return response;
        } else {
            throw new RackResponseModel(false,11106, 'Something went wrong');
        }
    }

    async getRacksForZoneId_org(zoneIdReq: ZoneByIdDto): Promise<RackDropDownResponseModel> {
        try {
            const racks: RackDropDownDto[] = [];
            const rackEntities: Rack[] = await this.rackRepository.find({ relations: ["rackPositionInfo"], where: { zoneId: zoneIdReq.zoneId, isActive: true, occupancy: 'Not Occupied' } })
            // const rackEntities: Rack[] = await this.rackRepository.createQueryBuilder('Rack').where(`Rack.zone_id = ${zoneIdReq.zoneId}`).orderBy("Rack.rackName", "ASC").getMany();
            console.log('rackEntities');
            console.log(rackEntities);
            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rackEntities => {
                    rackEntities.rackPositionInfo.forEach(rack => {
                        racks.push(new RackDropDownDto(rack.rackPositionId, rack.rackCode, rack.plantId));
                    })
                });
                const response = new RackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }
    async getRacksForZoneId(zoneIdReq: ZoneByIdDto): Promise<RackDropDownResponseModel> {
        try {
            const racks: RackDropDownDto[] = [];
            const manager = getManager();
            const rackEntities = await manager.query(`SELECT r.rack_id as rackId, rp.rack_position_id AS rackPositionId,rp.rack_code AS rackCode FROM rack_position rp LEFT JOIN rack r ON r.rack_id=rp.rack_id WHERE rp.is_active=1 AND rp.occupancy='Not Occupied' AND r.zone_id=`+zoneIdReq.zoneId);
            console.log('rackEntities');
            console.log(rackEntities.length);

            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rack => {
                    racks.push(new RackDropDownDto(rack.rackPositionId,rack.rackCode));                    
                });
                console.log(racks)
                const response = new RackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRacksForZone(zoneIdReq: ZoneByIdDto): Promise<RackDropDownResponseModel> {
        try {
            const racks: RackDropDownDto[] = [];
            const manager = getManager();
            const rackEntities: RackDropDownDto[] = await manager.query(`SELECT r.rack_id as rackId, r.rack_code AS rackCode, r.zone_id AS zoneId, r.rack_type AS rackType, count(rp.rack_position_id) AS cnt FROM rack r left join rack_position rp on rp.rack_id = r.rack_id WHERE r.is_active=true and rp.is_active = true AND r.zone_id=` + zoneIdReq.zoneId+ ` or r.allocated_zone_id =`+ zoneIdReq.zoneId +` and rp.is_active = true group by r.rack_id`);

            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rack => {
                    racks.push(new RackDropDownDto(rack.rackId, rack.rackCode,rack.zoneId,rack.rackType,rack.cnt));
                });
                console.log(racks)
                const response = new RackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }
    async getdummyRacksByZone(zoneIdReq: RacksForZoneId): Promise<RackDropDownResponseModel> {
        try {
            const racks: RackDropDownDto[] = [];
            const manager = getManager();
            const rackEntities = await manager.query(`SELECT r.rack_id as rackId, r.rack_name AS rackName FROM rack r WHERE r.zone_id=`+zoneIdReq.zoneId+ ` and r.reserved_for_dummy = `+ zoneIdReq.reservedForDummy);
            console.log('rackEntities');
            console.log(rackEntities.length);

            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rack => {
                    racks.push(new RackDropDownDto(rack.rackId,rack.rackName));                    
                });
                console.log(racks)
                const response = new RackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRacksForRackId(rackIdRequest: RackIdRequest): Promise<RackDropDownDto> {
        const rackId = rackIdRequest.rackId;
        console.log('rackId' + rackId);
        try {
            const rackEntities = await this.rackRepository.findOne({ where: { rackId: rackId } });
            console.log(rackEntities);
            if (rackEntities) {
                const response = new RackDropDownDto(rackEntities.rackId, rackEntities.rackCode,rackEntities.zoneId);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRackWithoutRelationsForUpdate(rackCode: String, rackName: String, id: number, zoneId:number, plantId:number): Promise<Rack> {
        const responseCode = await this.rackRepository.findOne({
            where: { rackCode: rackCode, zoneId:zoneId, rackId:id, plantId:plantId },
        });
        const responseNo = await this.rackRepository.findOne({
            where: { rackName: rackName, zoneId:zoneId, rackId:id, plantId:plantId  },
        });
        if (responseCode || responseNo) {
            if (responseCode && responseNo) {
                if (responseCode.rackId == responseNo.rackId) {
                    return responseCode;
                }
                else if (responseCode.rackId == id) {
                    return responseNo;
                }
                else if (responseNo.rackId == id) {
                    return responseCode;
                }
                else {
                    return responseCode;
                }
            }
            else if (responseCode && !responseNo) {
                return responseCode;
            }
            else if (responseNo && !responseCode) {
                return responseNo;
            }
        } else {
            return null;
        }
    }
    async transferRack(rackDetails:any): Promise<CommonResponse> {
        console.log(rackDetails);
        const manager = new GenericTransactionManager();
        const connection = getManager();
        try{
            await manager.startTransaction();
            let updatePlantId = await manager.getCustomRepository(RackRepository).update({ rackId: Raw(alias => `rack_id = (${rackDetails.rackId})`) }, { allocatedPlantId: rackDetails.allocatedPlantId, allocatedZoneId: rackDetails.allocatedZoneId });
            console.log(updatePlantId);
            if (updatePlantId.affected) {
                await manager.completeTransaction();
                return new CommonResponse(true, 1111, 'Rack Transfered Successfully');
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 9999, "Transfer Failed, Please Try Again")
            }
        }catch (err) {
            await manager.releaseTransaction();
            return err;
        }
    }

    async getRacksForZoneExceptFromZone(zoneIdReq: ZoneByIdDto): Promise<RackDropDownResponseModel> {
        try {
            const racks: RackDropDownDto[] = [];
            const manager = getManager();
            const rackEntities: RackDropDownDto[] = await manager.query(`SELECT r.rack_id as rackId, r.rack_code AS rackCode, r.zone_id AS zoneId, r.rack_type AS rackType, count(rp.rack_position_id) AS cnt FROM rack r left join rack_position rp on rp.rack_id = r.rack_id WHERE r.is_active=true and rp.is_active = true AND r.zone_id=` + zoneIdReq.zoneId+ ` or r.allocated_zone_id =`+ zoneIdReq.zoneId +` and rp.is_active = true group by r.rack_id`);

            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rack => {
                    racks.push(new RackDropDownDto(rack.rackId, rack.rackCode,rack.zoneId,rack.rackType,rack.cnt));
                });
                console.log(racks)
                const response = new RackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RackResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }


}
